import React from 'react'
import { useState, useEffect, useContext } from "react";
import UserContext from "../../common/helpers/userContext";
import { useHistory } from "react-router-dom";
import Cards from "../../common/components/Cards";
import Compressor from 'compressorjs';
import AdminDialog from "../../common/components/Dialogs/AdminDialog";
import { createService } from '../../common/services/serviceFactory'; // Importar serviceFactory
import axios from 'axios';

function ComboSection() {

    const { newCombos } = useContext(UserContext)
    const [allCombos, setAllCombos] = useState(newCombos)
    const [selectedCombo, setSelectedCombo] = useState({})

    const [openUpdateDialog, setOpenUpdateDialog] = useState(false)
    const [openCreateDialog, setOpenCreateDialog] = useState(false)

    const [isLoading, setIsLoading] = useState(false)

    const Router = useHistory()

    useEffect(() => {
        const comboService = createService('combos');
        const token = localStorage.getItem("accessToken");
        comboService.getAll(token)
            .then(data => setAllCombos(data))
            .catch(error => console.error("Error fetching combos:", error));
    }, []);

    useEffect(()=>{
        const accessToken = localStorage.getItem("accessToken")

        if (!accessToken) Router.push("/");
        const userService = createService('users');
        userService.getById("current", accessToken) // Assuming "current" fetches the logged-in user
            .then(user => {
                if (user && user.role !== 'admin') Router.push("/");
            })
            .catch(error => {
                console.error("Error fetching user data:", error);
                Router.push("/"); // Redirect if error or not admin
            });
    }, [Router]);

    //TODO:Ver como hacer para que los nuevos combos no sean 
    //     los de los Users, sino, los del Admin
    const [updateValues, setUpdateValues] =  useState ({name:"", price:"", image: "", provinceAvailability: [], isAvailable: true})
    const [toCreateCombo,setToCreateCombo] = useState ({name:"", price:"", image: "", provinceAvailability: [], isAvailable: true})


    const handleDataForUpdate = input => e => {
        setUpdateValues({...updateValues, [input]: e.target.value})
      }

    const handleChangeForUpdate = (event) => {
        setUpdateValues({...updateValues, isAvailable : event.target.checked});
      };

    const handleDataForCreating = input => e => {
      setToCreateCombo({...toCreateCombo, [input]: e.target.value})
      }

    const handleChangeForCreating = (event) => {
      setToCreateCombo({...toCreateCombo, isAvailable : event.target.checked});
      };

      const handlePrincipalImageChangeToUpdate = (e) => {
        const file = e.target.files[0];

        setIsLoading(true)

        new Compressor(file, {
            quality: 0.9,

            success(result) {
              const formData = new FormData();
              formData.append("file", result)
              formData.append("upload_preset", `zfvhwnfp`)
              axios.post("https://api.cloudinary.com/v1_1/milytravel/image/upload",formData)
              .then(e =>{
                const url = e.data.secure_url;
                setUpdateValues( { ...selectedCombo, image: url } );
                setIsLoading(false)
                return url;
            })
            .catch( e => {
              setIsLoading(false)
            })},
            error(err) {
              setIsLoading(false)
            },
          })
      }

    const handlePrincipalImageChangeToCreate = (e)=>{
    const file = e.target.files[0];

    setIsLoading(true)

    new Compressor(file, {
        quality: 0.9,

        success(result) {
          const formData = new FormData();
          formData.append("file", result)
          formData.append("upload_preset", `zfvhwnfp`)
          axios.post("https://api.cloudinary.com/v1_1/milytravel/image/upload",formData)
          .then(e =>{
            const url = e.data.secure_url;
            setToCreateCombo( { ...toCreateCombo, image: url } );
            setIsLoading(false)
            return url;
        })
  
        .catch( e => {
            
          setIsLoading(false)
        })},
        error(err) {
          setIsLoading(false)
        },
      })
      }

    const create = async () => {
        setIsLoading(true);
        const comboService = createService('combos');
        const token = localStorage.getItem("accessToken");
        try {
            const newCombo = await comboService.create(toCreateCombo, token);
            setAllCombos(prev => [newCombo, ...prev]);
            setOpenCreateDialog(false);
            setToCreateCombo({ name: "", price: "", image: "", provinceAvailability: [], isAvailable: true }); // Reset form
        } catch (error) {
            console.error("Error creating combo:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const update = async () => {
        setIsLoading(true);
        const comboService = createService('combos');
        const token = localStorage.getItem("accessToken");
        try {
            const updatedCombo = await comboService.update(selectedCombo._id, updateValues, token);
            setAllCombos(prev => prev.map(combo => combo._id === updatedCombo._id ? updatedCombo : combo));
            setOpenUpdateDialog(false);
        } catch (error) {
            console.error("Error updating combo:", error);
        } finally {
            setIsLoading(false);
        }
    };
  return (
    <div>
        <div className="flex justify-center">
        <button className="createButton" onClick={()=> setOpenCreateDialog(true)} >Crear Combo</button>
      </div>
    <div
     style={{ flexWrap: "wrap",
      gap: "30px",
      paddingTop: "35px"}}
     className="flex justify-center">
        {allCombos.map((singleCombo, key)=>
            <Cards
              key={key}
              setOpenDialog={setOpenUpdateDialog}
              setSelectedCombo={setSelectedCombo}
              setUpdateValues={setUpdateValues}
              singleCombo={singleCombo}
              allCombos={allCombos}
              setAllCombos={setAllCombos}
            />
            )}

        <AdminDialog
          handleData={handleDataForUpdate}
          handleChange={handleChangeForUpdate}
          setValues={setUpdateValues}
          handlePrincipalImageChange={handlePrincipalImageChangeToUpdate}
          isLoading={isLoading}
          openDialog={openUpdateDialog}
          setOpenDialog={setOpenUpdateDialog}
          callToActionFunction={update}
          Values={updateValues}
        />

        <AdminDialog
          handleData={handleDataForCreating}
          handleChange={handleChangeForCreating}
          handlePrincipalImageChange={handlePrincipalImageChangeToCreate}
          isLoading={isLoading}
          openDialog={openCreateDialog}
          setOpenDialog={setOpenCreateDialog}
          callToActionFunction={create}
          Values={toCreateCombo}
          setValues={setToCreateCombo}
        />
    </div>
    </div>
  )
}

export default ComboSection